export const SET_CS_CLAIM_PAGE_EXPERIENCE_ID = 'SET_CS_CLAIM_PAGE_EXPERIENCE_ID';

export const setCsClaimPageExperienceId = (payload: string | undefined) => ({
  type: SET_CS_CLAIM_PAGE_EXPERIENCE_ID,
  payload,
});
